import React, { useContext, useEffect, useState } from "react";
import { Route, Redirect } from "react-router-dom";
//import Auth from "./AuthHelperMethods"; // your singleton

// import AuthHelperMethods from "./AuthHelperMethods";

import Auth from "./Auth";

function PrivateRoute({ component: Component, ...rest }) {
  const [authLoading, setAuthLoading] = useState(Auth.isLoading());

  useEffect(() => {
    // When authReady resolves, trigger a re-render
    if (authLoading) {
      Auth.authReady.then(() => {
        setAuthLoading(false);
      });
    }
  }, []);

  /*const checkV = async () => {
    let result = await Auth.api("vusers/checkUserVersion", "get");
    console.log("checkV");
  };
  */

  return (
    <Route
      {...rest}
      render={(props) => {
        // *** NEW: don't render anything until auth is confirmed
        if (Auth.isLoading()) {
          return <div>Loading...</div>; // replace with your spinner component
        }

        return Auth.loggedIn() ? (
          <Component {...props} {...rest} />
        ) : (
          <Redirect
            to={{ pathname: "/login", state: { referer: props.location } }}
          />
        );
      }}
    />
  );

  /* return (
    <Route
      {...rest}
      render={(props) =>
        Auth.loggedIn() ? (
          <Component {...props} {...rest} />
        ) : (
          <Redirect
            to={{ pathname: "/login", state: { referer: props.location } }}
          />
        )
      }
    />
  );
  */
}

export default PrivateRoute;
